import { Link } from "@remix-run/react";

interface DynamicUrl {
  label: string;
  path: string;
}

interface GlobalCardDynamicUrlProps {
  dynamicUrls: DynamicUrl[];
  currentPath?: string;
}

export default function GlobalCardDynamicUrl({
  dynamicUrls,
  currentPath,
}: GlobalCardDynamicUrlProps) {
  return (
    <>
      {dynamicUrls.map((url) => {
        if (currentPath && url.path === currentPath) return null;

        return (
          <div
            className="bg-theme-secondary w-fit p-[1rem] rounded-lg"
            key={url.path}
          >
            <div>
              <Link
                to={url.path}
                className="text-black font-semibold hover:underline"
              >
                {url.label}
              </Link>
            </div>
          </div>
        );
      })}
    </>
  );
}
